import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {userGroupUrlCheck,getUserTimeZone} from '../../utils/userGroupUrlCheck';
import { ROUTE_AFFILIATE_SCHEDULE_VIEW,LOGIN_AFFILIATE_GROUP,ROUTE_CREW_AVAILABILITY_REPORTS, ROUTE_CREW_AVAIL_SUMMARY_REPORT} from '../../configs/staticConfigs';
import { LBL_CREW_NOT_ACCEPTED,LBL_APP_NAME,LBL_REPORTS,LBL_CREW_AVAILABILITY, LBL_CREW_AVAIL_SUMMARY_REPORT} from '../../configs/labelConfigs';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { fromReport} from '../../actions/commonActions';


class ReportListComponent extends Component {


    constructor(props){
        super(props)
    }

    goToReports = (e,report_name) =>{
    	let route_url = "";
    	if(report_name === "crew_availability"){
    		route_url = ROUTE_CREW_AVAILABILITY_REPORTS;
    	}else if(report_name === "crew_not_accepted"){
            this.props.fromReport(true);
            route_url = ROUTE_AFFILIATE_SCHEDULE_VIEW;
        } 
        else if(report_name === "crew_avail_summary"){
            this.props.fromReport(true);
            route_url = ROUTE_CREW_AVAIL_SUMMARY_REPORT;
        } 
    	this.props.history.push(route_url);
    }

    componentDidMount() {
    	const { location } = this.props;
    	let userGroupData = userGroupUrlCheck(location);
        let userGroup = ''; 
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
        } 
    	if(userGroup===LOGIN_AFFILIATE_GROUP){
            document.body.classList.add('body-affiliate'); 
        }
        document.title = LBL_APP_NAME+" - "+LBL_REPORTS; 
    }
    render(){
    	return(
    		<React.Fragment>
    			<div className="dashboard dash_width">
                    <div className="container">

                        <div className="dash-row stories margin-left-10">
                            <div className="dash-col3">
                                <div className="card ">
                                    <div className="card-body">
                                      <div className="dash-row align-items-center">
                                        <div className="dash-card-text h6 mb-2 p_text_color">
                                            <div className="href-link" onClick={(e) => this.goToReports(e,"crew_availability")}>
                                                {LBL_CREW_AVAILABILITY}
                                            </div>
                                        </div>
                                        <div className="dash-card-symbol">
                                          <span className="circle-info RedViolet reportFont"><i className="las la-user-alt"></i></span>
                                        </div> 
                                    </div>
                                  </div>
                                </div>
                            </div>
                            <div className="dash-col3">
                                <div className="card ">
                                    <div className="card-body">
                                      <div className="dash-row align-items-center">
                                        <div className="dash-card-text h6 mb-2 p_text_color">
                                            <div className="href-link" onClick={(e) => this.goToReports(e,"crew_avail_summary")}>
                                                {LBL_CREW_AVAIL_SUMMARY_REPORT}
                                            </div>
                                        </div>
                                        <div className="dash-card-symbol">
                                          <span className="circle-info Mandy reportFont"><i className="las la-users"></i></span>
                                        </div> 
                                    </div>
                                  </div>
                                </div>
                            </div>
                            <div className="dash-col3">
                                <div className="card ">
                                    <div className="card-body">
                                      <div className="dash-row align-items-center">
                                        <div className="dash-card-text h6 mb-2 p_text_color">
                                            <div className="href-link" onClick={(e) => this.goToReports(e,"crew_not_accepted")}>
                                                {LBL_CREW_NOT_ACCEPTED}
                                            </div>
                                        </div>
                                        <div className="dash-card-symbol">
                                          <span className="circle-info BlueRibbon reportFont"><i className="las la-user-slash"></i></span>
                                        </div> 
                                    </div>
                                  </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>

    		</React.Fragment>
    	)
    }
}

const mapStateToProps = (state) => {
    return {
    }
}           

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        fromReport:fromReport
    },dispatch);
}               


export default connect(mapStateToProps,mapDispatchToProps)(ReportListComponent);